// ThemeContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './auth/AuthContext';
import { getUserPreferences, setUserPreferences } from './userPreferences';

const ThemeContext = createContext();

export const useTheme = () => {
  return useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
  const { user } = useAuth();
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    setTheme((prevTheme) => {
      const nextTheme = prevTheme === 'light' ? 'dark' : 'light';
      if (user?.email) {
        setUserPreferences(user.email, { theme: nextTheme });
      }

      return nextTheme;
    });
  };

  useEffect(() => {
    if (!user?.email) {
      return;
    }

    const savedTheme = getUserPreferences(user.email).theme;
    if (savedTheme === 'light' || savedTheme === 'dark') {
      setTheme(savedTheme);
    }
  }, [user?.email]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
